import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

const BarChart2 = ({ series, categories }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    const defaultSeries = [
        {
            name: "Last Year",
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 91, 114, 94],
        },
        {
            name: "This Year",
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 91, 114, 94],
        },
    ];
    const defaultCategories = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const chartSeries = series || defaultSeries;
    const chartCategories = categories || defaultCategories;

    const labelColor = theme.palette.text.secondary;
    const ttTheme = isDark ? "dark" : "light";
    
    // Define colors for the series
    const colors = [theme.palette.grey[500], theme.palette.primary.main];

    const options = {
        series: chartSeries,
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
            background: "transparent",
        },
        colors: colors,
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 4,
                borderRadiusApplication: "end",
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: chartCategories,
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: "12px",
                    fontFamily: theme.typography.fontFamily,
                },
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        tooltip: {
            theme: ttTheme,
            y: {
                formatter: function (val) {
                    return val;
                },
            },
        },
        legend: {
            show: true,
            position: "top",
            horizontalAlign: "right",
            labels: {
                colors: labelColor,
                useSeriesColors: false
            },
            markers: {
                width: 12,
                height: 12,
                radius: 12
            },
            itemMargin: {
                horizontal: 10,
                vertical: 0
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: [labelColor],
                    fontSize: "12px",
                    fontFamily: theme.typography.fontFamily,
                },
            },
        },
        grid: {
            borderColor: theme.palette.divider,
            strokeDashArray: 4,
        },
        fill: {
            opacity: 1,
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    plotOptions: {
                        bar: {
                            columnWidth: "70%",
                        },
                    },
                },
            },
        ],
    };

    return (
        <div style={{ width: "100%", height: "100%", minHeight: "200px" }}>
            <ReactApexChart
                options={options}
                series={chartSeries}
                type="bar"
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default BarChart2;
